export default __webpack_public_path__ + "static/media/top-footer-2.4ba39109.png";